export const SUPER_ADMIN_NAME = "Ahmed Raza";
export const SUPER_ADMIN_ROLE = "Super Admin";

export const PROVIDERS = ["GeoWash", "Clean Car ME", "All"];
export const initialPackageSets = [
  {
    id: "set-1",
    name: "Standard Packages",
    provider: "GeoWash",
    status: "Active", // Active | Draft
    createdOn: "12 Jun 2026",
    locations: [
      "Shams 1",
      "Gate Towers",
      "Sun Tower",
      "Marina Heights",
      "Hydra Avenue",
      "Julphar Residence",
    ],
    warning: null,
    tiers: [
      {
        id: "t1",
        tier: "4 washes",
        days: "1x/wk",
        sedanPrice: 76,
        sedanPerWash: 19.0,
        sedanSaving: 9.5,
        suvPrice: 96,
        suvPerWash: 24.0,
        suvSaving: 7.7,
        popular: false,
        status: "Active",
      },
      {
        id: "t2",
        tier: "8 washes",
        days: "2x/wk",
        sedanPrice: 144,
        sedanPerWash: 18.0,
        sedanSaving: 14.3,
        suvPrice: 184,
        suvPerWash: 23.0,
        suvSaving: 11.5,
        popular: true,
        status: "Active",
      },
      {
        id: "t3",
        tier: "12 washes",
        days: "3x/wk",
        sedanPrice: 204,
        sedanPerWash: 17.0,
        sedanSaving: 19.0,
        suvPrice: 300,
        suvPerWash: 25.0,
        suvSaving: 3.8,
        popular: false,
        status: "Blocked",
        breach: true,
      },
    ],
    warningBanner: {
      title: "12-wash SUV breaches the 10% minimum saving guardrail.",
      body:
        "AED 25.00/wash against the AED 26 single cart wash is a 3.8% saving — the customer commits AED 300 upfront to save AED 12 over a month. Tier is blocked from publishing until the provider reprices or you approve an exception.",
    },
  },
  {
    id: "set-2",
    name: "Premium Packages",
    provider: "GeoWash",
    status: "Active",
    createdOn: "2 Jul 2026",
    locations: ["Al Muneera", "Al Zeina", "Etihad Towers Res.", "ADNOC HQ — Office", "Masdar City Res."],
    warning: null,
    tiers: [
      {
        id: "t4",
        tier: "4 washes",
        days: "1x/wk",
        sedanPrice: null,
        sedanPerWash: null,
        sedanSaving: null,
        suvPrice: null,
        suvPerWash: null,
        suvSaving: null,
        popular: false,
        status: "Off",
        disabled: true,
      },
      {
        id: "t5",
        tier: "8 washes",
        days: "2x/wk",
        sedanPrice: 152,
        sedanPerWash: 19.0,
        sedanSaving: 9.5,
        suvPrice: 192,
        suvPerWash: 24.0,
        suvSaving: 7.7,
        popular: false,
        status: "Active",
      },
      {
        id: "t6",
        tier: "12 washes",
        days: "3x/wk",
        sedanPrice: 216,
        sedanPerWash: 18.0,
        sedanSaving: 14.3,
        suvPrice: 276,
        suvPerWash: 23.0,
        suvSaving: 11.5,
        popular: true,
        status: "Active",
      },
    ],
    warningBanner: null,
  },
  {
    id: "set-3",
    name: "Draft Set — Residential",
    provider: "GeoWash",
    status: "Draft",
    createdOn: "18 Jul 2026",
    locations: [],
    tiers: [],
    warningBanner: {
      title: "Set has priced tiers but no locations attached — nothing is purchasable.",
      body:
        "Conversely, 2 locations are flagged for packages with no set assigned → see Package Locations tab.",
    },
  },
];
export const PROVIDER_NAME = "GeoWash";
export const LOCATIONS = ["Shams 1", "Gate Towers", "Al Muneera", "ADNOC HQ"];
export const STATUSES = ["Active", "Low delivery", "Expired", "Cancelled"];
export const PACKAGES = ["8 / month", "12 / month"];
 
export const initialOrders = [
  {
    id: "WAS-PKG-004182",
    customer: "N. Rugar",
    phone: "+971 5-...-421",
    location: "Shams 1",
    provider: "GeoWash",
    tier: "8 / month",
    car: "Sedan",
    days: "Mon · Thu",
    period: "1–31 Jul",
    paid: 149,
    washtaNet: 10.86,
    status: "Active",
    purchasedOn: "1 Jul 2026 · 09:14",
    money: {
      packagePrice: 144.0,
      platformFee: 5.0,
      customerCharged: 149.0,
      commissionPct: 8,
      commission: 11.52,
      stripeFeeLabel: "Stripe (2.9% + 1.00)",
      stripeFee: 5.32,
      washtaNet: 11.2,
      providerPayout: 132.48,
      payoutStatus: "Released",
      qboJournal: "JE-8841",
      qboStatus: "Posted",
    },
    deliveries: [
      { date: "Mon 6 Jul", status: "Completed", note: "GeoWash · 08:42" },
      { date: "Thu 9 Jul", status: "Completed", note: "GeoWash · 09:05" },
      { date: "Mon 13 Jul", status: "Missed", note: "no action by 23:59" },
      { date: "Thu 16 Jul", status: "Completed", note: "GeoWash · 08:31" },
      {
        date: "Mon 20 Jul",
        status: "Completed",
        note: "Superadmin — provider confirmed by phone",
        superadmin: true,
      },
      { date: "Thu 23 Jul", status: "Due today", note: "pending" },
      { date: "Mon 27 Jul", status: "Scheduled", note: "—" },
      { date: "Thu 30 Jul", status: "Scheduled", note: "—" },
    ],
  },
  {
    id: "WAS-PKG-004177",
    customer: "A. Haddad",
    phone: "+971 5-...-233",
    location: "Gate Towers",
    provider: "GeoWash",
    tier: "12 / month",
    car: "SUV",
    days: "Mon · Wed · Sat",
    period: "3 Jul–3 Aug",
    paid: 281,
    washtaNet: 20.72,
    status: "Active",
    purchasedOn: "3 Jul 2026 · 10:02",
    money: {
      packagePrice: 276.0,
      platformFee: 5.0,
      customerCharged: 281.0,
      commissionPct: 8,
      commission: 22.08,
      stripeFeeLabel: "Stripe (2.9% + 1.00)",
      stripeFee: 9.15,
      washtaNet: 20.72,
      providerPayout: 249.77,
      payoutStatus: "Released",
      qboJournal: "JE-8852",
      qboStatus: "Posted",
    },
    deliveries: [
      { date: "Wed 3 Jul", status: "Completed", note: "GeoWash · 08:00" },
      { date: "Sat 6 Jul", status: "Completed", note: "GeoWash · 08:20" },
      { date: "Mon 8 Jul", status: "Completed", note: "GeoWash · 08:10" },
      { date: "Wed 10 Jul", status: "Completed", note: "GeoWash · 08:05" },
      { date: "Sat 13 Jul", status: "Completed", note: "GeoWash · 08:12" },
      { date: "Mon 15 Jul", status: "Completed", note: "GeoWash · 08:19" },
      { date: "Wed 17 Jul", status: "Completed", note: "GeoWash · 08:22" },
      { date: "Sat 20 Jul", status: "Completed", note: "GeoWash · 08:14" },
      { date: "Mon 22 Jul", status: "Completed", note: "GeoWash · 08:30" },
      { date: "Wed 24 Jul", status: "Due today", note: "pending" },
      { date: "Sat 27 Jul", status: "Scheduled", note: "—" },
      { date: "Mon 29 Jul", status: "Scheduled", note: "—" },
    ],
  },
  {
    id: "WAS-PKG-004098",
    customer: "M. Sultan",
    phone: "+971 5-...-778",
    location: "Al Muneera",
    provider: "Clean Car ME",
    tier: "8 / month",
    car: "SUV",
    days: "Tue · Fri",
    period: "28 Jun–28 Jul",
    paid: 197,
    washtaNet: 14.55,
    status: "Low delivery",
    purchasedOn: "28 Jun 2026 · 11:40",
    money: {
      packagePrice: 192.0,
      platformFee: 5.0,
      customerCharged: 197.0,
      commissionPct: 8,
      commission: 15.36,
      stripeFeeLabel: "Stripe (2.9% + 1.00)",
      stripeFee: 6.71,
      washtaNet: 14.55,
      providerPayout: 169.93,
      payoutStatus: "Pending",
      qboJournal: "JE-8797",
      qboStatus: "Draft",
    },
    deliveries: [
      { date: "Tue 30 Jun", status: "Completed", note: "Clean Car ME · 09:12" },
      { date: "Fri 3 Jul", status: "Missed", note: "no action by 23:59" },
      { date: "Tue 7 Jul", status: "Completed", note: "Clean Car ME · 09:00" },
      { date: "Fri 10 Jul", status: "Missed", note: "no action by 23:59" },
      { date: "Tue 14 Jul", status: "Missed", note: "no action by 23:59" },
      { date: "Fri 17 Jul", status: "Missed", note: "no action by 23:59" },
      { date: "Tue 21 Jul", status: "Due today", note: "pending" },
      { date: "Fri 24 Jul", status: "Scheduled", note: "—" },
    ],
  },
  {
    id: "WAS-PKG-003940",
    customer: "R. Fernandes",
    phone: "+971 5-...-509",
    location: "ADNOC HQ",
    provider: "GeoWash",
    tier: "12 / month",
    car: "Sedan",
    days: "Sun · Tue · Thu",
    period: "20 Jun–20 Jul",
    paid: 221,
    washtaNet: 16.28,
    status: "Expired",
    purchasedOn: "20 Jun 2026 · 08:55",
    money: {
      packagePrice: 216.0,
      platformFee: 5.0,
      customerCharged: 221.0,
      commissionPct: 8,
      commission: 17.28,
      stripeFeeLabel: "Stripe (2.9% + 1.00)",
      stripeFee: 7.41,
      washtaNet: 16.28,
      providerPayout: 191.31,
      payoutStatus: "Released",
      qboJournal: "JE-8710",
      qboStatus: "Posted",
    },
    deliveries: [
      { date: "Sun 21 Jun", status: "Completed", note: "GeoWash · 07:50" },
      { date: "Tue 23 Jun", status: "Completed", note: "GeoWash · 07:55" },
      { date: "Thu 25 Jun", status: "Completed", note: "GeoWash · 08:02" },
      { date: "Sun 28 Jun", status: "Completed", note: "GeoWash · 08:00" },
      { date: "Tue 30 Jun", status: "Completed", note: "GeoWash · 07:58" },
      { date: "Thu 2 Jul", status: "Completed", note: "GeoWash · 08:05" },
      { date: "Sun 5 Jul", status: "Completed", note: "GeoWash · 08:01" },
      { date: "Tue 7 Jul", status: "Completed", note: "GeoWash · 08:03" },
      { date: "Thu 9 Jul", status: "Completed", note: "GeoWash · 08:04" },
      { date: "Sun 12 Jul", status: "Completed", note: "GeoWash · 08:06" },
      { date: "Tue 14 Jul", status: "Completed", note: "GeoWash · 08:02" },
      { date: "Thu 16 Jul", status: "Completed", note: "GeoWash · 08:00" },
      { date: "Sun 19 Jul", status: "Completed", note: "GeoWash · 08:09" },
    ],
  },
];
export const WASH_COUNT_CATALOG = [
  { id: "wc-4", washCount: 4, frequency: "1x/week", defaultName: "4 Washes / Month" },
  { id: "wc-8", washCount: 8, frequency: "2x/week", defaultName: "8 Washes / Month" },
  { id: "wc-12", washCount: 12, frequency: "3x/week", defaultName: "12 Washes / Month" },
];
 
export const WASH_INCLUDES_OPTIONS = [
  "Exterior wash only",
  "Exterior + Interior vacuum",
  "Exterior + Interior detail",
  "Full detail (interior + exterior + wax)",
];
 
/* Shared pool of locations. `setId` (null | "set-standard" | "set-premium" | ...)
   tells you which package set, if any, currently owns that location. */
export const initialLocationPool = [
  { id: "loc-shams1", name: "Shams 1", activePackages: 42, setId: "set-standard" },
  { id: "loc-gatetowers", name: "Gate Towers", activePackages: 31, setId: "set-standard" },
  { id: "loc-suntower", name: "Sun Tower", activePackages: 18, setId: "set-standard" },
  { id: "loc-marinaheights", name: "Marina Heights", activePackages: 12, setId: "set-standard" },
  { id: "loc-hydraavenue", name: "Hydra Avenue", activePackages: 9, setId: "set-standard" },
  { id: "loc-julphar", name: "Julphar Residence", activePackages: 6, setId: "set-standard" },
  { id: "loc-almuneera", name: "Al Muneera", activePackages: 27, setId: "set-premium" },
  { id: "loc-alzeina", name: "Al Zeina", activePackages: 15, setId: "set-premium" },
  { id: "loc-etihadtowers", name: "Etihad Towers Res.", activePackages: 8, setId: "set-premium" },
  { id: "loc-adnochq", name: "ADNOC HQ — Office", activePackages: 4, setId: "set-premium" },
  { id: "loc-masdarcity", name: "Masdar City Res.", activePackages: 3, setId: "set-premium" },
  { id: "loc-yasisland", name: "Yas Island Res.", activePackages: 0, setId: null },
  { id: "loc-cornichetower", name: "Corniche Tower", activePackages: 0, setId: null },
];
 
/* Two seeded package sets — "Standard Packages" and "Premium Packages" —
   ids match the setsById map already referenced inside LocationsSection. */
export const initialSets = [
  {
    id: "set-standard",
    name: "Standard Packages",
    locked: true, // first package already sold, washIncludes can no longer change
    washIncludes: "Exterior + Interior vacuum",
    vehicleTypes: ["Sedan", "SUV"],
    singleWashPrice: { Sedan: 21, SUV: 26 },
    packages: [
      {
        id: "pkg-std-4",
        washCatalogId: "wc-4",
        washCount: 4,
        frequency: "1x/week",
        name: "4 Washes / Month",
        nameLocked: true,
        on: true,
        popular: false,
        price: { Sedan: 76, SUV: 96 },
      },
      {
        id: "pkg-std-8",
        washCatalogId: "wc-8",
        washCount: 8,
        frequency: "2x/week",
        name: "8 Washes / Month",
        nameLocked: true,
        on: true,
        popular: true,
        price: { Sedan: 144, SUV: 184 },
      },
      {
        id: "pkg-std-12",
        washCatalogId: "wc-12",
        washCount: 12,
        frequency: "3x/week",
        name: "12 Washes / Month",
        nameLocked: true,
        on: false, // blocked — SUV saving breaches the 10% guardrail (3.8%)
        popular: false,
        price: { Sedan: 204, SUV: 300 },
      },
    ],
  },
  {
    id: "set-premium",
    name: "Premium Packages",
    locked: true,
    washIncludes: "Full detail (interior + exterior + wax)",
    vehicleTypes: ["Sedan", "SUV"],
    singleWashPrice: { Sedan: 21, SUV: 26 },
    packages: [
      {
        id: "pkg-prem-4",
        washCatalogId: "wc-4",
        washCount: 4,
        frequency: "1x/week",
        name: "4 Washes / Month",
        nameLocked: true,
        on: false, // switched off by provider
        popular: false,
        price: { Sedan: "", SUV: "" },
      },
      {
        id: "pkg-prem-8",
        washCatalogId: "wc-8",
        washCount: 8,
        frequency: "2x/week",
        name: "8 Washes / Month",
        nameLocked: true,
        on: true,
        popular: false,
        price: { Sedan: 152, SUV: 192 },
      },
      {
        id: "pkg-prem-12",
        washCatalogId: "wc-12",
        washCount: 12,
        frequency: "3x/week",
        name: "12 Washes / Month",
        nameLocked: true,
        on: true,
        popular: true,
        price: { Sedan: 216, SUV: 276 },
      },
    ],
  },
];